import { render, staticRenderFns } from "./wx-invite-landing.vue?vue&type=template&id=72b2f9fc&scoped=true&"
import script from "./wx-invite-landing.vue?vue&type=script&lang=js&"
export * from "./wx-invite-landing.vue?vue&type=script&lang=js&"
import style0 from "./wx-invite-landing.vue?vue&type=style&index=0&id=72b2f9fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2f9fc",
  null
  
)

export default component.exports